import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { PropertiesSelectors } from '../../../selectors';
import TourCardEditable from '../TourCardEditable';
import TourCardEmpty from '../TourCard/TourCardEmpty';

import { StyledCol, StyledRow } from './StyledComponents';

const propTypes = {
  tourType: PropTypes.oneOf(['amenity', 'singleFamily']),
  updateStatusMessage: PropTypes.func.isRequired,
};

const defaultProps = {
  tourType: 'amenity',
};

const ListingTour = ({ tourType, isDisabled, updateStatusMessage, isRelistingFieldset = false }) => {
  const { vrModels, externalTours, isMultifamily } = useSelector((state) =>
    PropertiesSelectors.makeCurrentProperty(state),
  );

  const listingToursCount = vrModels.length + externalTours.length;
  const showEmptyTour = listingToursCount === 0 || isMultifamily;

  const renderTour = (tour, index, isExternalTour) => {
    const isPublished = tour.status === 'published';
    const extraProps = { [isExternalTour ? 'externalTour' : 'vrModel']: tour };
    return (
      <StyledCol key={`${isExternalTour ? 'externalTour' : 'vrModel'}-${isPublished ? '' : 'un'}published-${index}`}>
        <TourCardEditable
          tourType={tourType}
          hasBigBottomBorder={true}
          isDisabled={isDisabled}
          size="md"
          updateStatusMessage={updateStatusMessage}
          {...extraProps}
        />
      </StyledCol>
    );
  };
  return (
    <>
      {listingToursCount === 0 ? (
        <TourCardEmpty
          listingToursCount={0}
          tourType={tourType}
          isRelistingFieldset={isRelistingFieldset}
          isDisabled={isDisabled}
        />
      ) : (
        <StyledRow>
          {vrModels
            .filter((vrModel) => vrModel.status === 'published')
            .map((vrModel, index) => renderTour(vrModel, index, false))}
          {externalTours
            .filter((vrModel) => vrModel.status === 'published')
            .map((externalTour, index) => renderTour(externalTour, index, true))}
          {vrModels
            .filter((vrModel) => vrModel.status !== 'published')
            .map((vrModel, index) => renderTour(vrModel, index, false))}
          {externalTours
            .filter((vrModel) => vrModel.status !== 'published')
            .map((externalTour, index) => renderTour(externalTour, index, true))}
          {showEmptyTour && (
            <TourCardEmpty
              tourType={tourType}
              listingToursCount={listingToursCount}
              isDisabled={isDisabled}
              isRelistingFieldset={isRelistingFieldset}
            />
          )}
        </StyledRow>
      )}
    </>
  );
};

ListingTour.propTypes = propTypes;
ListingTour.defaultProps = defaultProps;

export { ListingTour };
export default ListingTour;
